import OldAppHeaderLogo from './sswhite.svg';
import OldSetupPageLogo from './shipstation-logo-black.svg';

import RebrandAppHeaderLogo from './header-logo-light-rebrand.svg';
import RebrandSetupPageLogo from './shipstation-logo-black-rebrand.svg';

export const RebrandLogos = {
  AppHeaderLogo: RebrandAppHeaderLogo,
  SetupPageLogo: RebrandSetupPageLogo,
};

export const OldLogos = {
  AppHeaderLogo: OldAppHeaderLogo,
  SetupPageLogo: OldSetupPageLogo,
};
